<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <div v-if="idleLockEnabled && lockData" class="idle-lock-overlay">
      <div class="idle-lock-panel">
        <div class="idle-lock-title">请输入操作密码</div>
        <el-form
          :model="Form"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="idle-lock-form"
          @submit.native.prevent="submitForm('ruleForm')"
        >
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="Form.password"
              autocomplete="off"
              @keyup.enter.native="submitForm('ruleForm')"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" round icon="el-icon-check" @click="submitForm('ruleForm')">
              确 定
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog title="提示" style="" :visible="netWork" width="400px" :before-close="handleClose"
      :modal-append-to-body="false" center :show-close="false" custom-class="netDialog" :close-on-click-modal="false">
      <div class="netword">
        网络连接已断开,请检查网络
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import { setStore, getStore } from './utils/store.js'
import refreshTime from './config/refreshTime.js'
import { checkAndHandleCrossAppLogout } from '@/utils/crossAppLogout'
import {
  isIdleLockEnabled,
  getIdleLockPassword,
  getIdleLockTimeoutMs
} from '@/config/idleLock'
export default {
  name: "app",
  components: {},
  //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      Form: {
        password: "",
      },
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      timer: null,
      idleLockBodyHandlers: null,
      netWork: false,
      versionCheckInterval: null
    };
  },
  computed: {
    idleLockEnabled() {
      return isIdleLockEnabled()
    },
    lockData() {
      return this.$store.state.lockScreen;
    },
    ...mapGetters(["userInfo"]),
  },
  watch: {
    $route(to) {
      this.contractCache();
    },
  },
  methods: {
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (!valid) {
          return false
        }
        const expected = getIdleLockPassword()
        if (!expected) {
          this.$message.error('未配置解锁密码，请在环境变量 VUE_APP_IDLE_LOCK_PASSWORD 中设置')
          return false
        }
        if (this.Form.password !== expected) {
          this.$message.error('密码错误，请重新输入！')
          return false
        }
        this.$message.success('解锁成功')
        this.unlockScreen()
      })
    },
    unlockScreen() {
      this.$store.commit('changeLock', false)
      sessionStorage.setItem('lock', false)
      this.Form.password = ''
      this.resetIdleLockTimer()
    },
    applyIdleLock() {
      sessionStorage.setItem('lock', true)
      this.$store.commit('changeLock', true)
    },
    resetIdleLockTimer() {
      if (!this.idleLockEnabled) {
        return
      }
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        this.applyIdleLock()
      }, getIdleLockTimeoutMs())
    },
    bindIdleLockActivity() {
      if (!this.idleLockEnabled) {
        return
      }
      const handler = () => {
        if (this.$store.state.lockScreen) {
          return
        }
        this.resetIdleLockTimer()
      }
      const events = ['mouseup', 'keyup', 'click', 'touchend']
      this.idleLockBodyHandlers = { handler, events }
      events.forEach((name) => {
        document.body.addEventListener(name, handler)
      })
      this.resetIdleLockTimer()
    },
    unbindIdleLockActivity() {
      if (this.idleLockBodyHandlers) {
        const { handler, events } = this.idleLockBodyHandlers
        events.forEach((name) => {
          document.body.removeEventListener(name, handler)
        })
        this.idleLockBodyHandlers = null
      }
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startVersionCheck() {
      this.versionCheckInterval = setInterval(() => {
        this.contractCache();
        console.log("版本检查中...");
        
      }, refreshTime.versionUpdate.updateTime*1000);
    },
    contractCache() {
      axios
        .get(`/configVersion.json`, {
          params: {
            _t: new Date().getTime(),
          },
        })
        .then((res) => {
          console.log(res.data);
          
          const VUE_APP_VERSION = res.data.version;
          const vers = getStore({ name: 'Version' })
          if (vers) {
            if (VUE_APP_VERSION != vers) {
              setTimeout(() => {
                setStore({ name: 'Version', content: VUE_APP_VERSION })
                location.reload();
              }, 2000);
            }
          } else {
            setStore({ name: 'Version', content: VUE_APP_VERSION })
          }
        });
    },
  },
  mounted() {
    if (checkAndHandleCrossAppLogout()) {
      const loginUrl = process.env.VUE_APP_ADMIN_LOGIN_URL || `${process.env.VUE_APP_ADMIN_URL}/login`;
      window.location.href = loginUrl;
      return;
    }
    sessionStorage.setItem("lock", false)
    this.$store.commit('changeLock', false)
    if (this.idleLockEnabled) {
      this.bindIdleLockActivity()
    }
    let that = this
    window.addEventListener('offline', function () {
      console.log('网络连接中断!');
      that.netWork = true;
    });
    window.addEventListener('online', function () {
      console.log('网络连接恢复!');
      that.netWork = false;
    });
    this.startVersionCheck()
  },
  beforeDestroy() {
    this.unbindIdleLockActivity()
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval);
    }
  },
};
</script>

<style lang="scss">
.idle-lock-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(3, 16, 38, 0.92);
  backdrop-filter: blur(2px);
}

.idle-lock-panel {
  width: 420px;
  max-width: 90vw;
  padding: 28px 32px 16px;
  border-radius: 8px;
  border: 1px solid #2b5fce;
  background: #031026;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
}

.idle-lock-title {
  margin-bottom: 20px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.idle-lock-form {
  .el-form-item__label {
    color: rgba(255, 255, 255, 0.85);
  }

  .el-button {
    margin-left: 80px;
  }
}

.netDialog {
  background: #031026 !important;
  font-size: 18px;
  border: 1px solid #2b5fce;
}

.netword {
  padding: 20px 0;
  color: red;
  text-align: center;
  font-size: 20px;
}
</style>
